import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import toFa from '../../helpers/toFa';

const StatsItem = ({ className, title, all, responded }) => {
    return (
        <div className={className}>
            <div className="StatsItem__Title">
                <h3>{title}</h3>
            </div>
            <div className="StatsItem__Details">
                <div className="StatsItem__Detail">
                    <span>پاسخ داده شده</span>
                    <span className="StatsItem__Count">{`${toFa(
                        responded
                    )} مورد`}</span>
                </div>
                <div className="StatsItem__Detail">
                    <span>پرسیده شده</span>
                    <span className="StatsItem__Count">{`${toFa(
                        all
                    )} مورد`}</span>
                </div>
            </div>
        </div>
    );
};

StatsItem.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    all: PropTypes.string.isRequired,
    responded: PropTypes.string.isRequired
};

export default styled(StatsItem)`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    background: #ffffff;
    border-radius: 5px;
    padding: 13px 19px;
    box-shadow: 0 3px 10px #e8ebff;
    margin-bottom: 20px;

    .StatsItem__Title {
        h3 {
            font-size: 12px;
            font-weight: bold;
            line-height: 21px;
            color: #0d1fa1;
        }
    }

    .StatsItem__Detail {
        margin-bottom: 7px;
        text-align: left;

        &:last-child {
            margin-bottom: 0;
        }

        span {
            font-size: 12px;
            font-weight: 300;
            line-height: 21px;
            color: #0d1fa1;
        }

        .StatsItem__Count {
            padding: 4px 16px;
            margin-right: 37px;
            background-color: #0d1fa1;
            border-radius: 14px;
            font-weight: 400;
            color: #ffffff;
        }
    }
`;
